import {
  BudgetableUserReadModel,
  InitOverrideFunction,
  UserManagementApi,
  UserManagementSetDisplayBudgetPatchRequest,
} from "../../../@api";

export class UserManagementApiService
  implements Omit<UserManagementApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: UserManagementApi) {}

  public userManagementGetAllUserData(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<BudgetableUserReadModel>> {
    return this.api.userManagementGetAllUserData(initOverrides);
  }

  public userManagementGetDisplayBudget(initOverrides?: RequestInit | InitOverrideFunction): Promise<boolean> {
    return this.api.userManagementGetDisplayBudget(initOverrides);
  }

  public userManagementSetDisplayBudgetPatch(
    requestParameters?: UserManagementSetDisplayBudgetPatchRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.userManagementSetDisplayBudgetPatch(requestParameters, initOverrides);
  }
}
